import React from 'react'
import { validators } from '../../utils/helpers/validators'
import RolesDropDown from '../roles/RolesDropDown'
import { ControlLabel } from '../common/form-components/label/Label'
import SaveButton from '../common/buttons/SaveButton'
import LabeledText from '../common/form-components/labeled-inputs/LabeledText'
import './users-form.scss'
import CentersDropdown from '../centers/CentersDropdown'

const UsersForm = ({ inputs, handleChange, handleSubmit }) => {
  const validateForm =
    validators.hasValue(inputs?.name) &&
    validators.hasValue(inputs?.username) &&
    validators.emailFormat(inputs?.email) &&
    validators.hasValue(inputs?.role)

  return (
    <div className="users-form-container">
      <div className="modal-content-wrapper">
        <LabeledText
          eledInput
          idLabel="full.name"
          required
          name="name"
          value={inputs?.name}
          onChange={(e) => handleChange(e)}
        />

        <LabeledText
          idLabel="user"
          required
          name="username"
          value={inputs?.username}
          onChange={(e) => handleChange(e)}
        />

        <LabeledText
          idLabel="email"
          required
          name="email"
          value={inputs?.email}
          onChange={(e) => handleChange(e)}
        />

        <CentersDropdown
          idLabel="center"
          name="center"
          value={inputs?.center}
          onChange={(e) => handleChange(e)}
        />

        {/* <CentersDropdown
                    idLabel='center'
                    name='center'
                    
                    onChange={(e) => handleChange(e)}
                /> */}

        <div className="flex-container">
          <ControlLabel id="role" required />
          <div className="control-input roles">
            <RolesDropDown
              value={inputs?.role}
              onChange={(e) => handleChange(e)}
            />
          </div>
        </div>
      </div>
      <div className="modal-btn-container">
        <SaveButton btnClass="btn-save-modal" onClick={() => handleSubmit()} />
      </div>
    </div>
  )
}

export default UsersForm
